export default __webpack_public_path__ + "static/media/printer.36d19735.svg";